import { Component } from '@angular/core';

@Component({
  selector: 'hdw-about-organ-transport',
  templateUrl: './about-organ-transport.component.html',
  styleUrls: ['./about-organ-transport.component.scss']
})
export class AboutOrganTransportComponent {
  public canShowOrganTransplantCenter = false;
  public canShowOrgansTransplanted = false;
  public canShowScientificRegistry = false;
  public canShowOrganProcurement = false;

  public handleOrganTransplantCenter(): void {
    this.canShowOrganTransplantCenter = !this.canShowOrganTransplantCenter;
  }
  public handleWhatOrgansCanBeTransplanted(): void {
    this.canShowOrgansTransplanted = !this.canShowOrgansTransplanted;
  }

  public handleScientificRegistry(): void {
    this.canShowScientificRegistry = !this.canShowScientificRegistry;
  }

  public handleOrganProcurement(): void {
    this.canShowOrganProcurement = !this.canShowOrganProcurement;
  }
}
